import React from 'react';

interface BrandSpinnerProps {
  fullscreen?: boolean;
  message?: string;
}

const LETTERS = Array.from('LETTERWEAVE');

const BrandSpinner: React.FC<BrandSpinnerProps> = ({ fullscreen = false, message = 'Preparing puzzle…' }) => {
  return (
    <div className={`brand-spinner ${fullscreen ? 'fullscreen' : ''}`}> 
      <div className="brand-letters" aria-label="Loading">
        {LETTERS.map((ch, i) => (
          <span key={i} className="brand-letter" style={{ animationDelay: `${i * 0.08}s` }}>
            {ch}
          </span>
        ))}
      </div>
      <div className="brand-message">{message}</div>
    </div>
  );
};

export default BrandSpinner;


